module.exports = __webpack_public_path__ + "static/media/UnPokoroSetting.031aabf3.svg";